import React from 'react';

const DynamicSky = ({ 
  timeOfDay = 'evening', 
  planetaryInfluence = 'jupiter',
  dasha = 'venus' 
}) => {
  // Sky configurations based on influences
  const skyConfigs = {
    // Time of day
    morning: {
      gradient: 'linear-gradient(180deg, #fef3c7 0%, #fde68a 50%, #fcd34d 100%)',
      overlay: 'rgba(251, 191, 36, 0.1)',
    },
    afternoon: {
      gradient: 'linear-gradient(180deg, #dbeafe 0%, #bfdbfe 50%, #93c5fd 100%)',
      overlay: 'rgba(59, 130, 246, 0.1)',
    },
    evening: {
      gradient: 'linear-gradient(180deg, #e8ddff 0%, #d4c5f9 50%, #b69ef0 100%)',
      overlay: 'rgba(155, 125, 232, 0.1)',
    },
    night: {
      gradient: 'linear-gradient(180deg, #1e293b 0%, #0f172a 50%, #020617 100%)',
      overlay: 'rgba(15, 23, 42, 0.3)',
    },
  };

  // Planetary influence overlays
  const planetaryOverlays = {
    sun: { color: '#fbbf24', stars: false },
    moon: { color: '#e0f2fe', stars: true },
    mars: { color: '#ef4444', stars: false },
    mercury: { color: '#10b981', stars: false },
    jupiter: { color: '#edc161', stars: true },
    venus: { color: '#ec4899', stars: true },
    saturn: { color: '#6b7280', stars: true },
    rahu: { color: '#7c3aed', stars: true },
    ketu: { color: '#a855f7', stars: true },
  };

  const skyConfig = skyConfigs[timeOfDay] || skyConfigs.evening;
  const planetConfig = planetaryOverlays[planetaryInfluence] || planetaryOverlays.jupiter;

  // Generate random stars
  const stars = planetConfig.stars
    ? Array.from({ length: 30 }, (_, i) => ({
        id: i,
        x: Math.random() * 100,
        y: Math.random() * 60, // Top 60% of sky
        size: Math.random() * 2 + 1,
        opacity: Math.random() * 0.5 + 0.3,
        delay: Math.random() * 3,
      }))
    : [];

  return (
    <div 
      className="absolute inset-0 overflow-hidden pointer-events-none"
      style={{ background: skyConfig.gradient }}
    >
      {/* Planetary overlay */}
      <div
        className="absolute inset-0"
        style={{
          background: `radial-gradient(circle at 50% 20%, ${planetConfig.color}20 0%, transparent 60%)`,
        }}
      />

      {/* Stars */}
      {stars.map((star) => (
        <div
          key={star.id}
          className="absolute rounded-full bg-white animate-pulse"
          style={{
            left: `${star.x}%`,
            top: `${star.y}%`,
            width: `${star.size}px`,
            height: `${star.size}px`,
            opacity: star.opacity,
            animationDelay: `${star.delay}s`,
            animationDuration: '3s',
          }}
        />
      ))}

      {/* Gradient overlay for depth */}
      <div
        className="absolute inset-0"
        style={{ background: skyConfig.overlay }}
      />

      {/* Bottom fade to content */}
      <div
        className="absolute bottom-0 left-0 right-0 h-32"
        style={{
          background: 'linear-gradient(to bottom, transparent, var(--bg-color, #fafaf9))',
        }}
      />
    </div>
  );
};

export default DynamicSky;